// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3On7r","content":"styles_content__3V12d","row":"styles_row__3A_tK","footer":"styles_footer__1u4EO","phraseLength":"styles_phraseLength__1qxXh"};